export default __webpack_public_path__ + "static/links-imani-03-a8368dda6bd02c67d2570f92063d6fda.png";